export function startPanicSirensEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  let root = imgPanelEl.querySelector('.panic-sirens');
  if (!root) {
    root = document.createElement('div');
    root.className = 'panic-sirens';
    root.innerHTML = '<div class="siren-beam beam-1"></div><div class="siren-beam beam-2"></div>';
    imgPanelEl.appendChild(root);
  }

  return () => {
    if (root && root.parentNode) root.parentNode.removeChild(root);
  };
}
